export const getDefaultState = () => {
  return {
    /**
     * See createUndoAction() in ./helpers.js for UndoAction structure.
     * This array stores either UndoAction Objects or Arrays of them.
     *
     * Example: [UndoAction, [UndoAction, UndoAction], UndoAction]
     * - On Undo, the singular UndoAction affects one cell
     * - Undoing an array handles multiple actions at once with one 'ctrl+z'
     */
    undoActions: [],
    lastUndoAction: null,
    isUndoing: false,
  };
};
export const state = getDefaultState();
